import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'bxs-bar-chart-alt-2',
        link: '/dashboard',
    },
    {
        id: 3,
        label: 'MENUITEMS.ARBRES.TEXT',
        icon: 'bxs-tree',
        link: '/arbres',
    },
    {
        id: 11,
        label: 'MENUITEMS.MARAICHAGE.TEXT',
        icon: 'bxs-florist',
        link: '/maraichage',
    },
    {
        id: 4,
        label: 'MENUITEMS.BETAIL.TEXT',
        icon: 'bx-receipt',
        link: '/betail',
    },
    {
        id: 5,
        label: 'MENUITEMS.PARTENAIRES.TEXT',
        icon: 'bxs-user-detail',
        link: '/partenaires',
    },
    {
        id: 6,
        label: 'MENUITEMS.PERSONNEL.TEXT',
        icon: 'bx-group',
        link: '/personnel',
    },
    {
        id: 7,
        label: 'MENUITEMS.UTILISATEURS.TEXT',
        icon: 'bx-group',
        link: '/users',
    },
    {
        id: 8,
        label: 'MENUITEMS.PARAMETRAGES.TEXT',
        isTitle: true
    },
    {
        id: 9,
        label: 'MENUITEMS.FICHEMESURE.TEXT',
        icon: 'bx-tone',
        link: '/fiches-mesures',
    },
    {
        id: 10,
        label: 'MENUITEMS.ABONNEMENT.TEXT',
        icon: 'bxs-dollar-circle',
        link: '/abonnement',
    },
];


export const MENU_ADMIN: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'bxs-bar-chart-alt-2',
        link: '/dashboard',
    },
    {
        id: 3,
        label: 'MENUITEMS.MAISONCOUTURE.TEXT',
        icon: 'bx-building-house',
        link: '/fermes',
    },
    {
        id: 4,
        label: 'MENUITEMS.UTILISATEURS.TEXT',
        icon: 'bx-group',
        link: '/users',
    },
    {
        id: 7,
        label: 'MENUITEMS.PARAMETRAGES.TEXT',
        isTitle: true
    },
    {
        id: 6,
        label: 'MENUITEMS.ROLES.TEXT',
        icon: 'bx-tone',
        link: '/roles',
    },
    {
        id: 8,
        label: 'MENUITEMS.FICHEMESURE.TEXT',
        icon: 'bx-tone',
        link: '/fiches-mesures',
    },
    {
        id: 9,
        label: 'MENUITEMS.ABONNEMENT.TEXT',
        icon: 'bxs-dollar-circle',
        link: '/abonnement',
    },
];

